import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  textContent: 'Please select an organization'
}
const _hoisted_2 = { class: "flex-wrap w-full" }
const _hoisted_3 = {
  key: 0,
  class: "text-red-600 text-center"
}
const _hoisted_4 = {
  key: 0,
  textContent: 'Please select an organization'
}
const _hoisted_5 = {
  key: 0,
  class: "w-full p-3 border-bottom-1 border-100"
}
const _hoisted_6 = { class: "font-bold text-red-600" }

import { ref, onBeforeMount, onUpdated, toRefs, watch } from 'vue';
import UserRemoveReferral from './UserRemoveReferral.vue';
import Calendar from 'primevue/calendar';
import InputNumber from 'primevue/inputnumber';
import InputMask from 'primevue/inputmask';
import { EMIT, FREQUENCY_INTERVALS_OPTIONS, FREQUENCY_AMOUNT, PERMISSIONS, REFERRAL_TYPES } from '@/enum';
import { useStudentReferralStore, useServicesStore, useClinicianOrganizationStore } from '@/store';
import useUserTreatmentPlansStore from '@/store/People/Person/TreatmentPlans';
import { can, useDateTime } from '@/composables';
import { ReferralProcessInterface, DisciplineStateInterface } from '@/types';
import { DropdownChangeEvent } from 'primevue/dropdown';
import { OrganizationBuildingInterface } from '@/types/BuildingInterface';

interface Props {
  save: boolean;
  organizationId?: number;
  buildings: OrganizationBuildingInterface[];
  disciplines: DisciplineStateInterface[];
  services: DisciplineStateInterface[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TransferReferralTable',
  props: {
    save: { type: Boolean },
    organizationId: {},
    buildings: {},
    disciplines: {},
    services: {}
  },
  emits: [EMIT.SAVE],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;
const { save, organizationId } = toRefs(props);
const removeIndex = ref<number>(0);
const openRemove = ref<boolean>(false);

const referralStore = useStudentReferralStore();
const servicesStore = useServicesStore();
const treatmentPlanStore = useUserTreatmentPlansStore();
const clinicianStore = useClinicianOrganizationStore();

const frequencyIntervals = FREQUENCY_INTERVALS_OPTIONS;
const frequencyAmount = FREQUENCY_AMOUNT;

watch(
  () => referralStore.referralOptionsloading,
  () => {
    if (!referralStore.referralOptionsloading) {
      const referralTypeId = referralStore.referralTypes.find((type) => type.title === REFERRAL_TYPES.TRANSFER).id;

      referralStore.transferReferralTableData.forEach((item) => (item.referral_type.value = referralTypeId));
    }
  },
);

const init = () => {
  referralStore.transferReferralTableData = [];
  for (let i = 0; i < 3; i++) makeBaseRow(i);
};

const makeBaseRow = (index: number) => {
  const referralType = REFERRAL_TYPES.TRANSFER;
  const referralTypeId = referralStore.getReferralTypeId(referralType);
  const referral = referralStore.newRow(referralType);

  if (referral) {
    referral.key = index;
    referral.referral_type.value = referralTypeId as number;
    referralStore.transferReferralTableData.push(referral);
  }
};

const validRow = (row) => {
  let valid = false;
  row.errors = null;
  const errorMessage = 'All required fields must be filled out.';

  if (row.row_status.completed) {
    return true;
  }

  if (row.id.value === '') {
    row.errors = null;
    return false;
  }

  if (
    organizationId.value &&
    row.referral_type.value !== '' &&
    row.id.value !== '' &&
    row.first_name.value !== '' &&
    row.last_name.value !== '' &&
    row.row_status.disable === false &&
    row.row_status.processing === false
  ) {
    if (row.disciplines.value === '') {
      valid = true;
    } else if (
      row.disciplines.value !== '' &&
      row.service_line.value !== '' &&
      row.service_start.value !== '' &&
      row.service_end.value !== '' &&
      row.interval.value !== '' &&
      row.frequency.value !== ''
    ) {
      valid = true;
    } else {
      row.errors = errorMessage;
    }
  } else {
    row.errors = errorMessage;
  }

  return valid;
};

onUpdated(async () => {
  if (save.value === true) {
    referralStore.transferReferralTableData.forEach(async (row, index) => {
      if (!row.row_status.completed) {
        setTimeout(async () => {
          if (validRow(row)) {
            row.row_status.disable = true;
            row.row_status.processing = true;

            let payload: ReferralProcessInterface = {
              organization_id: organizationId.value as number,
              referral_type_id: row.referral_type.value,
              student_id: row.id.value,
              student_sis_id: row.student_sis_id.value,
              student_first_name: row.first_name.value,
              student_last_name: row.last_name.value,
              student_country: row.student_country.value,
              student_state: row.student_state.value,
              student_city: row.student_city.value,
              zipcode: row.zip.value,
              building_campus: props.buildings.find((b) => b.id === row.location.value)?.name,
              building_id: row.location.value,
              gender: row.gender.value,
              birthdate: row.birthdate.value !== '' ? useDateTime().formatDateForApi(row.birthdate.value) : '',
              grade: row.grade.value,
              phone: row.phone.value,
              parent_sis_id: row.parent_sis_id.value,
              parent_first_name: row.parent_first_name.value,
              parent_last_name: row.parent_last_name.value,
              parent_email: row.parent_email.value,
              referred_discipline_id: row.referred_discipline.value,
              discipline_id: row.disciplines.value !== '' ? row.disciplines.value : null,
              service_provider_id: row.service_provider.value,
              service_id: row.service_line.value,
              treatment_plan_type_id: row.treatment_plan_type.value,
              treatment_plan_category_id: row.service_category.value,
              treatment_plan_service_type_id: row.service_type.value,
              treatment_service_start_at:
                row.service_start.value !== '' && row.service_start.value !== null
                  ? useDateTime().formatDateForApi(row.service_start.value)
                  : '',
              treatment_service_end_at:
                row.service_end.value !== '' && row.service_end.value !== null
                  ? useDateTime().formatDateForApi(row.service_end.value)
                  : '',
              treatment_service_duration: row.duration.value,
              treatment_service_frequency: row.frequency.value,
              treatment_service_interval:
                row.interval.value !== '' && row.interval.value !== null ? row.interval.value.toLowerCase() : '',
              integration_provider_type_slug: row.integration_provider_type_slug.value,
            };

            payload = referralStore.parseCustomReferralTypes(payload);

            await referralStore.process(payload, index, REFERRAL_TYPES.TRANSFER);

            handleProcessedRow(row);

            if (referralStore.error) referralStore.error = false;
          }
        }, index * 500);
      }
    });
    scrollBack();
    emit(EMIT.SAVE);
  }
});

const scrollBack = () => {
  const scrollableContainer = document.getElementById('transferTable');
  const childTable = scrollableContainer?.getElementsByClassName('p-datatable-wrapper');
  if (childTable)
    childTable[0]?.scroll({
      left: 0,
      behavior: 'smooth',
    });
};

const handleProcessedRow = (row) => {
  const errorLength = row.errors?.length;
  row.row_status.disable = !errorLength;
  row.row_status.completed = !errorLength;
  row.row_status.processing = false;

  if (!errorLength) row.errors = null;
};

const onTreatmentPlanTypeSelect = async (e: DropdownChangeEvent) => {
  await treatmentPlanStore.getTreatmentPlanCategories(e.value as number);
};

const onUpdateRemove = () => {
  openRemove.value = false;
  referralStore.transferReferralTableData.splice(removeIndex.value, 1);
};

const onRemoveRow = (index: number) => {
  if (referralStore.transferReferralTableData.length > 1) {
    removeIndex.value = index;
    openRemove.value = true;
  }
};

const endDateInvalid = (startDate: Date | string, endDate: Date | string) => {
  let invalid = false;
  if (endDate !== '' && endDate !== null && startDate !== '' && startDate !== null) {
    invalid = endDate.getTime() <= startDate.getTime();
  }
  return invalid;
};

const hasDisciplineSelected = (discipline: string, value: string): boolean => {
  if (discipline !== '' && value === null) {
    return true;
  }

  if (discipline !== '' && value === '') {
    return true;
  }

  return false;
};

const serviceRelateFieldDisabled = (discipline: string, disable: boolean) => discipline === '' || disable;

const checkStartDate = (date: Date | string) => (date !== '' ? date : null);

onBeforeMount(() => init());

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(UserRemoveReferral, {
      open: openRemove.value,
      onUpdate: onUpdateRemove,
      onCancel: _cache[0] || (_cache[0] = ($event: any) => (openRemove.value = false))
    }, null, 8, ["open"]),
    _createVNode(_component_DataTable, {
      id: "transferTable",
      value: _unref(referralStore).transferReferralTableData,
      class: "border-solid border-1 border-100 border-round-md",
      rows: _unref(referralStore).transferReferralTableData.length,
      "data-key": "key",
      scrollable: "",
      "scroll-direction": "horizontal",
      "loading-icon": "logo-spinner",
      "responsive-layout": "scroll",
      "row-group-mode": "subheader",
      "group-rows-by": "key"
    }, {
      groupfooter: _withCtx((slotProps) => [
        (slotProps.data.errors)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_Icon, {
                name: "subdirectory_arrow_right",
                class: "mr-2 text-base text-red-600"
              }),
              _createElementVNode("span", _hoisted_6, "Errors - " + _toDisplayString(slotProps.data.errors), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          class: "text-center",
          style: {"max-width":"40px"},
          frozen: true
        }, {
          header: _withCtx(() => [
            _createVNode(_component_Icon, {
              name: "add_circle",
              class: "add__row__icon cursor-pointer",
              onClick: makeBaseRow
            })
          ]),
          body: _withCtx(({ data, index }) => [
            (!data.row_status.processing && !data.row_status.completed)
              ? (_openBlock(), _createBlock(_component_Icon, {
                  key: 0,
                  name: "remove_circle",
                  class: "remove__row__icon cursor-pointer",
                  value: data.id.value,
                  disabled: _unref(referralStore).mTSSReferralTableData.length < 2,
                  onClick: ($event: any) => (onRemoveRow(index))
                }, null, 8, ["value", "disabled", "onClick"]))
              : _createCommentVNode("", true),
            (data.row_status.processing)
              ? (_openBlock(), _createBlock(_component_Icon, {
                  key: 1,
                  name: "cached",
                  class: "text-primary spin-cached"
                }))
              : _createCommentVNode("", true),
            (data.row_status.completed)
              ? (_openBlock(), _createBlock(_component_Icon, {
                  key: 2,
                  name: "check_circle",
                  class: "text-primary"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "referral_type",
          header: "Referral Type",
          "header-class": "required w-screen",
          frozen: true
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Dropdown, {
              modelValue: data.referral_type.value,
              "onUpdate:modelValue": ($event: any) => ((data.referral_type.value) = $event),
              type: "secondary",
              options: _unref(referralStore).referralTypes,
              "option-label": "title",
              "option-value": "id",
              placeholder: "Referral Type",
              class: "w-full",
              disabled: data.row_status.disable,
              onChange: ($event: any) => (_unref(referralStore).onReferralTypeChange(data, _unref(REFERRAL_TYPES).TRANSFER))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "id",
          header: "SSID",
          "header-class": "required",
          style: {"max-width":"150px"},
          frozen: true
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_InputText, {
              modelValue: data.id.value,
              "onUpdate:modelValue": ($event: any) => ((data.id.value) = $event),
              placeholder: "SSID",
              disabled: data.row_status.disable,
              class: "w-full"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "first_name",
          header: "Student First Name",
          "header-class": "required",
          style: {"width":"100px"},
          frozen: true
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_InputText, {
              modelValue: data.first_name.value,
              "onUpdate:modelValue": ($event: any) => ((data.first_name.value) = $event),
              placeholder: "Student First Name",
              disabled: data.row_status.disable,
              class: "w-full"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "last_name",
          header: "Student Last Name",
          "header-class": "required",
          style: {"width":"100px"},
          frozen: true
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_InputText, {
              modelValue: data.last_name.value,
              "onUpdate:modelValue": ($event: any) => ((data.last_name.value) = $event),
              placeholder: "Student Last Name",
              disabled: data.row_status.disable,
              class: "w-full"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "zip",
          header: "Zip Code",
          style: {"max-width":"150px"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_InputText, {
              modelValue: data.zip.value,
              "onUpdate:modelValue": ($event: any) => ((data.zip.value) = $event),
              "use-grouping": false,
              placeholder: "Zip Code",
              disabled: data.row_status.disable,
              class: "w-full"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
          ]),
          _: 1
        }),
        (__props.buildings && __props.buildings.length > 0)
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 0,
              field: "location",
              header: "Building/Campus",
              style: {"width":"250px"}
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_Dropdown, {
                  modelValue: data.location.value,
                  "onUpdate:modelValue": ($event: any) => ((data.location.value) = $event),
                  options: __props.buildings,
                  "option-label": "name",
                  "option-value": "id",
                  placeholder: "Select Building/Campus",
                  class: "w-full",
                  disabled: data.row_status.disable
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_Column, {
          field: "treatment_plan_type",
          header: "Treatment Plan Type",
          style: {"min-width":"280px"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Dropdown, {
              modelValue: data.treatment_plan_type.value,
              "onUpdate:modelValue": ($event: any) => ((data.treatment_plan_type.value) = $event),
              type: "secondary",
              options: _unref(treatmentPlanStore).treatmentPlanTypes,
              placeholder: "Select Treatment Plan Type",
              "option-value": "id",
              "option-label": "name",
              class: "w-full",
              disabled: data.row_status.disable,
              onChange: onTreatmentPlanTypeSelect
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "service_category",
          header: "Service Category",
          style: {"min-width":"240px"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Dropdown, {
              modelValue: data.service_category.value,
              "onUpdate:modelValue": ($event: any) => ((data.service_category.value) = $event),
              type: "secondary",
              disabled: data.treatment_plan_type.value === '' || data.row_status.disable,
              options: _unref(referralStore).treatmentPlanCategoriesByRowTreatmentPlanType(data.treatment_plan_type.value),
              "option-value": "id",
              "option-label": "name",
              placeholder: "Select Service Category",
              class: "w-full"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "options"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "referred_discipline",
          header: "Referred Discipline",
          "header-class": "w-screen",
          style: {"max-width":"250px"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Dropdown, {
              modelValue: data.referred_discipline.value,
              "onUpdate:modelValue": ($event: any) => ((data.referred_discipline.value) = $event),
              type: "secondary",
              options: props.disciplines,
              "option-label": "name",
              "option-value": "id",
              placeholder: "Select Discipline",
              class: "w-full",
              "append-to": "body"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "services",
          header: "Service",
          style: {"min-width":"240px"}
        }, {
          body: _withCtx(({ data }) => [
            (!_unref(organizationId))
              ? (_openBlock(), _createElementBlock("span", _hoisted_1))
              : (_openBlock(), _createBlock(_component_Dropdown, {
                  key: 1,
                  modelValue: data.disciplines.value,
                  "onUpdate:modelValue": ($event: any) => ((data.disciplines.value) = $event),
                  type: "secondary",
                  options: __props.services,
                  disabled: data.treatment_plan_type.value === '' || data.row_status.disable,
                  "option-label": "name",
                  "option-value": "id",
                  placeholder: "Select Service",
                  class: "w-full"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled"]))
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "service_line",
          header: "Service Line",
          style: {"min-width":"200px"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Dropdown, {
              modelValue: data.service_line.value,
              "onUpdate:modelValue": ($event: any) => ((data.service_line.value) = $event),
              type: "secondary",
              options: _unref(servicesStore).services,
              disabled: serviceRelateFieldDisabled(data.disciplines.value, data.row_status.disable),
              "option-label": "name",
              "option-value": "id",
              placeholder: "Select Service Line",
              class: _normalizeClass({
            'w-full': true,
            'p-invalid': hasDisciplineSelected(data.disciplines.value, data.service_line.value),
          })
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled", "class"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "service_type",
          header: "Service Type",
          style: {"min-width":"200px"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Dropdown, {
              modelValue: data.service_type.value,
              "onUpdate:modelValue": ($event: any) => ((data.service_type.value) = $event),
              type: "secondary",
              options: _unref(referralStore).serviceTypes,
              disabled: serviceRelateFieldDisabled(data.disciplines.value, data.row_status.disable),
              placeholder: "Select Service Type",
              "option-label": "title",
              "option-value": "id",
              class: _normalizeClass({
            'w-full': true,
            'p-invalid': hasDisciplineSelected(data.disciplines.value, data.service_type.value),
          })
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled", "class"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "gender",
          header: "Gender"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Dropdown, {
              modelValue: data.gender.value,
              "onUpdate:modelValue": ($event: any) => ((data.gender.value) = $event),
              type: "secondary",
              options: _unref(referralStore).genderOptions,
              disabled: data.row_status.disable,
              "option-label": "name",
              "option-value": "value",
              placeholder: "Select Gender",
              class: "w-full"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "birthdate",
          header: "Birth Date",
          style: {"min-width":"200px"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_unref(Calendar), {
              id: "birthdate",
              modelValue: data.birthdate.value,
              "onUpdate:modelValue": ($event: any) => ((data.birthdate.value) = $event),
              disabled: data.row_status.disable,
              placeholder: "mm/dd/yyyy",
              "date-format": "mm/dd/yy",
              "manual-input": true,
              class: "w-full"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "grade",
          header: "Grade"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Dropdown, {
              modelValue: data.grade.value,
              "onUpdate:modelValue": ($event: any) => ((data.grade.value) = $event),
              type: "secondary",
              options: _unref(referralStore).gradeOptions,
              disabled: data.row_status.disable,
              placeholder: "Select Grade",
              class: "w-full"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "phone",
          header: "Phone"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_unref(InputMask), {
              id: "phone",
              modelValue: data.phone.value,
              "onUpdate:modelValue": ($event: any) => ((data.phone.value) = $event),
              mask: "(999) 999-9999",
              placeholder: "(999) 999-9999",
              disabled: data.row_status.disable,
              class: "w-full"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "parent_first_name",
          header: "Parent First Name"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_InputText, {
              modelValue: data.parent_first_name.value,
              "onUpdate:modelValue": ($event: any) => ((data.parent_first_name.value) = $event),
              placeholder: "Parent First Name",
              disabled: data.row_status.disable,
              class: "w-full"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "parent_last_name",
          header: "Parent Last Name"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_InputText, {
              modelValue: data.parent_last_name.value,
              "onUpdate:modelValue": ($event: any) => ((data.parent_last_name.value) = $event),
              placeholder: "Parent Last Name",
              disabled: data.row_status.disable,
              class: "w-full"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "parent_email",
          header: "Parent Email"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_InputText, {
              modelValue: data.parent_email.value,
              "onUpdate:modelValue": ($event: any) => ((data.parent_email.value) = $event),
              placeholder: "Parent Email",
              disabled: data.row_status.disable
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "service_start",
          header: "Service Start Date",
          style: {"min-width":"180px"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_unref(Calendar), {
              id: "service_start",
              modelValue: data.service_start.value,
              "onUpdate:modelValue": ($event: any) => ((data.service_start.value) = $event),
              placeholder: "mm/dd/yyyy",
              "date-format": "mm/dd/yy",
              "manual-input": true,
              disabled: serviceRelateFieldDisabled(data.disciplines.value, data.row_status.disable),
              class: _normalizeClass({
            'w-full': true,
            'p-invalid': hasDisciplineSelected(data.disciplines.value, data.service_start.value),
          })
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "class"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "service_end",
          header: "Service End Date",
          style: {"min-width":"180px"}
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(Calendar), {
                id: "service_end",
                modelValue: data.service_end.value,
                "onUpdate:modelValue": ($event: any) => ((data.service_end.value) = $event),
                placeholder: "mm/dd/yyyy",
                "date-format": "mm/dd/yy",
                "min-date": checkStartDate(data.service_start.value),
                "manual-input": true,
                disabled: serviceRelateFieldDisabled(data.disciplines.value, data.row_status.disable),
                class: _normalizeClass({
              'w-full': true,
              'p-invalid':
                endDateInvalid(data.service_start.value, data.service_end.value) ||
                hasDisciplineSelected(data.disciplines.value, data.service_end.value),
            })
              }, null, 8, ["modelValue", "onUpdate:modelValue", "min-date", "disabled", "class"]),
              (endDateInvalid(data.service_start.value, data.service_end.value))
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("small", null, "End must come after Start", -1)
                  ]))]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "duration",
          header: "Duration"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_unref(InputNumber), {
              modelValue: data.duration.value,
              "onUpdate:modelValue": ($event: any) => ((data.duration.value) = $event),
              placeholder: "Duration",
              disabled: serviceRelateFieldDisabled(data.disciplines.value, data.row_status.disable),
              class: _normalizeClass({
            'w-full': true,
            'p-invalid': hasDisciplineSelected(data.disciplines.value, data.duration.value),
          })
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "class"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "interval",
          header: "Interval",
          style: {"width":"100px"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Dropdown, {
              modelValue: data.interval.value,
              "onUpdate:modelValue": ($event: any) => ((data.interval.value) = $event),
              type: "secondary",
              options: _unref(frequencyIntervals),
              "option-value": "value",
              "option-label": "label",
              placeholder: "Select Interval",
              disabled: serviceRelateFieldDisabled(data.disciplines.value, data.row_status.disable),
              class: _normalizeClass({ 'w-full': true, 'p-invalid': hasDisciplineSelected(data.disciplines.value, data.interval.value) })
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled", "class"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "frequency",
          header: "Frequency",
          style: {"min-width":"180px"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Dropdown, {
              modelValue: data.frequency.value,
              "onUpdate:modelValue": ($event: any) => ((data.frequency.value) = $event),
              type: "secondary",
              options: _unref(frequencyAmount),
              "option-value": "value",
              "option-label": "label",
              placeholder: "Select Frequency",
              disabled: serviceRelateFieldDisabled(data.disciplines.value, data.row_status.disable),
              class: _normalizeClass({ 'w-full': true, 'p-invalid': hasDisciplineSelected(data.disciplines.value, data.frequency.value) })
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled", "class"])
          ]),
          _: 1
        }),
        (_unref(can)([_unref(PERMISSIONS).REFERRAL_ASSIGN]))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 1,
              field: "service_provider",
              header: "Service Provider",
              style: {"min-width":"250px"}
            }, {
              body: _withCtx(({ data }) => [
                (!_unref(clinicianStore).clinicians || !_unref(clinicianStore).clinicians.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4))
                  : (_openBlock(), _createBlock(_component_Dropdown, {
                      key: 1,
                      modelValue: data.service_provider.value,
                      "onUpdate:modelValue": ($event: any) => ((data.service_provider.value) = $event),
                      type: "secondary",
                      options: _unref(clinicianStore).clinicians,
                      disabled: data.row_status.disable,
                      "option-label": "display_name",
                      "option-value": "id",
                      placeholder: "Select Service Provider",
                      class: "w-full"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled"]))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["value", "rows"])
  ], 64))
}
}

})